export class ShowSoilByIdUseCase {
  constructor(repository) {
    this.repository = repository
  }
  async execute(id) {
    const resp= await this.repository.getSoilById(id)

    return resp
  }
}
